import api from '@/utils/api';

/**
 * Get all users
 * @param {string} filter - filter
 * @returns {Promise}
 */
const getQuotesApi = (filter) => api.get(`quote?${filter}`);

export default getQuotesApi;
